export default __webpack_public_path__ + "static/media/icon6.8fbc23f0.svg";